module.exports = __webpack_public_path__ + "bbd096b591d6a3f24dcdc3ca72a420f4.woff";